const SITE_ORIGIN = 'https://www.theopenleague.com';
const DEFAULT_OG_IMAGE = `${SITE_ORIGIN}/logo512.png`;

const BLOG_POSTS = [
  {
    slug: 'online-soccer-manager-alternative',
    title: 'Online Soccer Manager (OSM) alternative',
    description:
      'Online Soccer Manager alternative where your club carries on: free football manager, 3-week seasons, a 7 pm league match nightly, rivals in Discord.',
  },
  {
    slug: 'top-eleven-alternative',
    title: 'Top Eleven alternative with human rivals',
    description:
      'Top Eleven alternative for friends: The Open League is a free football manager with 3-week seasons, a league match nightly at 7 pm and a Discord league.',
  },
  {
    slug: 'hattrick-alternative',
    title: 'Hattrick alternative with three-week seasons',
    description:
      'Hattrick alternative with a faster clock: The Open League is a free browser football manager with three-week seasons, nightly matches and a Discord league.',
  },
  {
    slug: 'free-football-manager-alternative',
    title: 'Free football manager alternative — social, not a clone',
    description:
      'Looking for a free football manager alternative? The Open League is free: short seasons, Discord match nights, human transfers — a social pick, not another FM clone.',
  },
  {
    slug: 'football-manager-with-friends',
    title: 'Football manager with friends — free social leagues',
    description:
      'Want a football manager with friends without hosting FM Online? The Open League is free: short seasons, Discord match nights, human transfers — play together on phone or web.',
  },
  {
    slug: 'play-football-manager-on-phone',
    title: 'Play football manager on phone — free, no Netflix',
    description:
      'Want Football Manager on your phone without Netflix? Play The Open League free in your browser: short seasons, Discord match nights, human transfers.',
  },
  {
    slug: 'free-football-manager-online',
    title: 'Free football manager online: play without the 400-hour save',
    description:
      'Looking for a free football manager online? The Open League is a free-to-play social football manager with short seasons, Discord match nights, and human transfers — built for managers who don’t have all day.',
  },
  {
    slug: 'discord-football-manager',
    title: 'Discord football manager: play a social FM on Discord',
    description:
      'Looking for a Discord football manager? The Open League runs daily matches, transfers, and leagues with your community — built for managers who don’t have all day.',
  },
  {
    slug: 'online-football-manager-games',
    title: 'An overview of online football manager games',
    description:
      'Explore the world of football management and find your next challenge.',
  },
  {
    slug: 'being-a-football-manager',
    title: 'The role and responsibilities of being an online football manager',
    description:
      'From choosing your starting eleven to building a squad: explore life in the dugout.',
  },
  {
    slug: 'evolution-of-football-manager-games',
    title: 'The evolution of online football manager games',
    description:
      'Discover how the virtual pitch became a home for football managers around the world.',
  },
];

const BLOG_SLUGS = BLOG_POSTS.map((post) => post.slug);

function blogPostBySlug(slug) {
  return BLOG_POSTS.find((post) => post.slug === slug) || null;
}

const PAGE_SEO = {
  home: {
    title: 'The Open League - Free football (soccer) manager game.',
    description:
      'The Open League is a Free-To-Play online football manager game. Compete against your friends and make history. Your Club, Your Legacy.',
    path: '/',
  },
  signup: {
    title: 'Sign up | The Open League',
    description:
      'Create your manager account and claim a club in The Open League, a free online football manager.',
    path: '/signup',
    robots: 'noindex, follow',
  },
  // Logged-in lobby (exact /home only; /home/player/* is untouched). Server
  // head only: keep it out of the index without redirecting signed-in users.
  lobby: {
    title: 'Club lobby | The Open League',
    description:
      'Your club lobby in The Open League, a free online football manager.',
    path: '/home',
    robots: 'noindex, follow',
  },
  blog: {
    title: 'Blog | The Open League',
    description:
      'Articles about online football manager games, tactics, and life in the dugout from The Open League.',
    path: '/blog',
  },
  pressKit: {
    title: 'Press Kit | The Open League',
    description:
      'Press resources, logos, screenshots, and media information for The Open League.',
    path: '/press-kit',
  },
  privacy: {
    title: 'Privacy Policy | The Open League',
    description:
      'Privacy policy for The Open League, a free-to-play online football manager game.',
    path: '/privacy',
  },
  terms: {
    title: 'Terms of Service | The Open League',
    description:
      'Terms of service for The Open League, a free-to-play online football manager game.',
    path: '/terms',
  },
  // Public account deletion request page (Google Play's deletion link). Indexable
  // so reviewers and users can find it; not in the curated sitemap.
  deleteAccount: {
    title: 'Delete your account | The Open League',
    description:
      'Ask us to delete your The Open League account and personal data. No login needed: see what we delete and send a request.',
    path: '/delete-account',
    robots: 'index, follow',
  },
};

const USER_GUIDE_SEO = {
  start: {
    title: 'User Guide: Getting Started | The Open League',
    description:
      'Learn the basics of The Open League: community rules, bots, and server time.',
  },
  players: {
    title: 'User Guide: Players | The Open League',
    description:
      'Understand player ratings, attributes, and development in The Open League.',
  },
  'off-season': {
    title: 'User Guide: Off Season | The Open League',
    description:
      'How the off-season works for clubs and managers in The Open League.',
  },
  trading: {
    title: 'User Guide: Trading | The Open League',
    description:
      'Transfer and trading guidance for The Open League managers.',
  },
  competitions: {
    title: 'User Guide: Competitions | The Open League',
    description:
      'Leagues, cups, and competition formats in The Open League.',
  },
  coaching: {
    title: 'User Guide: Coaching | The Open League',
    description:
      'Coaching, tactics, and training guidance for The Open League.',
  },
  finances: {
    title: 'User Guide: Finances | The Open League',
    description:
      'Club finances, wages, and budgeting in The Open League.',
  },
};

function absoluteUrl(path) {
  if (!path) return SITE_ORIGIN;
  if (path.startsWith('http')) return path;
  return `${SITE_ORIGIN}${path.startsWith('/') ? path : `/${path}`}`;
}

/** Normalize pathname for SEO lookup (no query/hash; no trailing slash except `/`). */
function normalizeSeoPath(pathname) {
  if (!pathname) return '/';
  let path = String(pathname).split('?')[0].split('#')[0];
  if (!path.startsWith('/')) path = `/${path}`;
  if (path.length > 1 && path.endsWith('/')) path = path.slice(0, -1);
  return path || '/';
}

/**
 * Resolve public SEO meta for a request path, or null if the path is not a
 * known public SEO URL (SPA shell should be sent unchanged).
 * Titles/descriptions match client Seo / Helmet usage.
 */
function resolvePublicSeo(pathname) {
  const path = normalizeSeoPath(pathname);

  if (path === '/') {
    return { ...PAGE_SEO.home, type: 'website' };
  }
  if (path === '/home') {
    return { ...PAGE_SEO.lobby, type: 'website' };
  }
  if (path === '/signup') {
    return { ...PAGE_SEO.signup, type: 'website' };
  }
  if (path === '/blog') {
    return { ...PAGE_SEO.blog, type: 'website' };
  }
  if (path === '/press-kit') {
    return { ...PAGE_SEO.pressKit, type: 'website' };
  }
  if (path === '/privacy') {
    return { ...PAGE_SEO.privacy, type: 'website' };
  }
  if (path === '/terms') {
    return { ...PAGE_SEO.terms, type: 'website' };
  }
  if (path === '/delete-account') {
    return { ...PAGE_SEO.deleteAccount, type: 'website' };
  }

  const blogMatch = path.match(/^\/blog\/([^/]+)$/);
  if (blogMatch) {
    const post = blogPostBySlug(blogMatch[1]);
    if (!post) return null;
    return {
      title: `${post.title} | The Open League`,
      description: post.description,
      path: `/blog/${post.slug}`,
      type: 'article',
    };
  }

  const guideMatch = path.match(/^\/user-guide\/([^/]+)$/);
  if (guideMatch) {
    const section = guideMatch[1];
    const meta = USER_GUIDE_SEO[section];
    if (!meta) return null;
    return {
      title: meta.title,
      description: meta.description,
      path: `/user-guide/${section}`,
      type: 'website',
    };
  }

  return null;
}

module.exports = {
  SITE_ORIGIN,
  DEFAULT_OG_IMAGE,
  BLOG_POSTS,
  BLOG_SLUGS,
  blogPostBySlug,
  PAGE_SEO,
  USER_GUIDE_SEO,
  absoluteUrl,
  normalizeSeoPath,
  resolvePublicSeo,
};
